"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatsByIdOperation = void 0;
exports.getStatsByIdOperation = {
    method: 'GET',
    name: 'getStatsById',
    id: 'GetStatsByStreamId',
    groupName: 'stats',
    urlPathPattern: '/stats/{streamId}',
    urlPathParamNames: ['streamId'],
    getRequestUrlParams: getRequestUrlParams,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams(request) {
    return {
        streamId: request.streamId,
    };
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest(request) {
    return request;
}
function deserializeRequest(jsonRequest) {
    return jsonRequest;
}
//# sourceMappingURL=getStatsByIdOperation.js.map